/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Failed_DeckInputs */



/**
* | output |
* | --- |
* | "the winner's deck could not be prepared" |
*
* @param {Twda_Failed_DeckInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_failed_deck = /** @type {((inputs?: Twda_Failed_DeckInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Failed_DeckInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("le deck du vainqueur n'a pas pu être préparé")
	if (locale === "es") return /** @type {LocalizedString} */ ("el mazo del ganador no se pudo preparar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("o deck do vencedor não pôde ser preparado")
	if (locale === "it") return /** @type {LocalizedString} */ ("il mazzo del vincitore non è stato preparato")
	return /** @type {LocalizedString} */ ("the winner's deck could not be prepared")
});